import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ShoppingCart } from 'lucide-react';
import { useCart } from '../../context/CartContext';
import './FloatingCart.css';

const FloatingCart = () => {
  const { cartCount, isCartBouncing, isBadgePopping } = useCart();
  const location = useLocation();

  // Only show cart on home, catalog and offers pages
  const visibleRoutes = ['/', '/test-catalog', '/tests', '/self-pay-lab-tests', '/offers'];
  const isVisible = visibleRoutes.some(route => location.pathname === route || location.pathname.substring(0, route.length) === route);

  if (!isVisible) {
    return null;
  }

  return (
    <Link 
      id="floating-cart-btn"
      to="/cart" 
      className={`floating-cart-btn fade-in ${isCartBouncing ? 'is-bouncing' : ''}`} 
      aria-label="View Cart"
    >
      <ShoppingCart className="floating-cart-icon" />
      {cartCount > 0 && <span className={`floating-cart-badge ${isBadgePopping ? 'is-popping' : ''}`}>{cartCount}</span>}
    </Link>
  );
};

export default FloatingCart;
